import { API_URL } from '../utils/api';

class ProductApis {
  constructor(storeId) {
    this.storeId = storeId;
  }


  // Get store products with optional filtering (matches mobile app functionality)
  async getStoreProducts({ categoryId = 0, searchTerm = '', skip = 0, take = 20 } = {}) {
    try {
      // Build the query parameters exactly like the mobile app
      const params = new URLSearchParams();
      if (searchTerm && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
      }
      params.append('skip', skip.toString());
      params.append('take', take.toString());
      if (categoryId > 0) {
        params.append('subcategoryId', categoryId.toString());
      }

      const url = `${API_URL}/products/store/${this.storeId}/search?${params.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          return data.products || [];
        } else {
          throw new Error(data.error || 'Failed to fetch store products');
        }
      } else {
        const error = await response.json();
        console.error('Error fetching store products:', error);
        return [];
      }
    } catch (error) {
      console.error('Error fetching store products:', error);
      return [];
    }
  }



  // Get the store's unique variations with their items and detail items
  // (deduplicated across products — variations are store-scoped and shared).
  // Shape: variations[] { id, variation_title, variation_items[] { id, variation_name,
  //   variation_item_details[] { id, variation_detail_title, variation_item_detail_items[] { id, item_name } } } }
  async getStoreVariations() {
    // Pull the full variation tree the store uses THROUGH its products (same scoping as
    // store_products), not by variations.store_id — retailers often use variations they
    // don't "own". Returns variations -> items -> detail items -> 3rd-level detail items.
    const url = `${API_URL}/products/store/${this.storeId}/variation-tree`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        const list = data.variations || [];
        console.log(`getStoreVariations: storeId=${this.storeId} url=${url} -> ${list.length} variations`);
        return list;
      } else {
        console.error('Error fetching store variations:', response.status, url, await response.text());
        return [];
      }
    } catch (error) {
      console.error('Error fetching store variations:', url, error);
      return [];
    }
  }

  // Get product subcategories (matching mobile app functionality)
  async getProductSubcategories() {
    try {
      const response = await fetch(`${API_URL}/subcategories/store/${this.storeId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          return data.subcategories || [];
        } else {
          throw new Error(data.error || 'Failed to fetch product subcategories');
        }
      } else {
        const error = await response.json();
        console.error('Error fetching product subcategories:', error);
        return [];
      }
    } catch (error) {
      console.error('Error fetching product subcategories:', error);
      return [];
    }
  }
}

export default ProductApis; 